export default "/corgi/pageapps/prepurchase/_next/static/media/safari-pinned-tab.208ac0c1.svg";